/**
 * Enable all accordions that exist in the DOM at page load.
 */
H_Tools?.accordions?.enableAccordions(document);
H_Tools?.accordions?.restoreAccordionState(document);
